import React, { useCallback, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Typography } from '@material-ui/core';
import Modal, { IGenericModalProps } from 'components/GenericModal/GenericModal';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { IModalProps } from 'store/modules/ModalsReducer';
import Documento from './Documento';
import useStyle from './style';
import { DocumentoResponse } from 'api/Associado/documentos';

export interface EditarDocumentosModalGenericProps extends IGenericModalProps {
  key: string;
  idAssembleia: number;
  listaDocumentos: DocumentoResponse[];
}

export interface EditarDocumentosModalProps extends IModalProps {
  genericProps: EditarDocumentosModalGenericProps;
}

export default function EditarDocumentosModal({ genericProps }: EditarDocumentosModalProps) {
  const { t } = useTranslation();
  const classes = useStyle();
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(modalsActionsClose(genericProps.key));
  }, [dispatch, genericProps]);

  return (
    <Modal
      title={t('EditarDocumentosModalAssociado.title')}
      genericProps={{
        maxWidth: 'sm',
        onClose: handleClose,
        DialogContentProps: {
          className: classes.content,
        },
      }}
      content={
        <Fragment>
          {
            genericProps.listaDocumentos.length! ? 
            genericProps.listaDocumentos.map(documento => <Documento idEvento={genericProps.idAssembleia} {...documento} />)
              : (
                <div className={classes.emptyMessage}>
                  <Typography component="p">{t('EditarDocumentosModalAssociado.empty')}</Typography>
                </div>
              )
          }
        </Fragment>
      }
    />
  );
}
